/* Copyright (c) 2024 MOCA Systems, Inc.  All rights reserved. */
/**
 * All supported cursor styles we use in the PIXI renderer
 */
export enum CursorType {
	None = `none`,
	Default = `default`,
	Help = `help`,
	Pointer = `pointer`,
	Progress = `progress`,
	Wait = `wait`,
	Cell = `cell`,
	CrossHair = `crosshair`,
	Text = `text`,
	VerticalText = `vertical-text`,
	Copy = `copy`,
	NotAllowed = `not-allowed`,
	NoDrop = `no-drop`,
	ZoomIn = `zoom-in`,
	ZoomOut = `zoom-out`,
	Grab = `grab`,
	Grabbing = `grabbing`,
	RowResize = `row-resize`,
}
